<template>
  <el-drawer
    v-if="visible"
    :title="title"
    :visible="visible"
    direction="rtl"
    :size="800"
    show-close
    @close="close"
    :before-close="handleClose"
    append-to-body
  >
    <div class="drawer-main">
      <edit-form
        ref="base"
        :deviceCode="deviceCode"
        :disabled="disabled"
        @close="saveClose"
      />
      <div class="d-flex justify-content-end mb-2 mt-2">
        <el-button v-if="!disabled" type="primary" size="small" @click="save">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </div>
    </div>
  </el-drawer>
</template>
<script>
import EditForm from '../components/edit-form'
import { mapActions } from 'vuex'
export default {
  name: 'inventory-maintenance-detail',
  components: { EditForm },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    deviceCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {}
  },
  computed: {},
  methods: {
    ...mapActions('admin/page', ['close']),
    onBeforeLeave() {
      return true
    },
    // saveOkQuestion() {
    //   this.$alert(
    //     this.$l('INDEX.tips_save_ok') || '保存成功',
    //     this.$l('INDEX.tips_question_title') || '提示信息',
    //     {
    //       confirmButtonText: '确定',
    //       callback: () => {
    //         this.$emit('close')
    //       },
    //     }
    //   )
    // },
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    saveClose() {
      this.close()
      this.$emit('reload')
    },

    async handleClose(done) {
      if (this.disabled) {
        done()
        return
      }
      this.$confirm(
        this.$l('INDEX.tips_check_saved') ||
          '如对当前页面内容做过修改，请先保存后再关闭。',
        this.$l('INDEX.tips_close_page') || '确认关闭当前页面吗',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText:
            this.$l('INDEX.product_dialog_btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(async () => {
          done()
        })
        .catch(() => {})
    },
    async save() {
      await this.$refs.base.save()
    },
  },
}
</script>
<style lang="scss" scoped>
.drawer-main {
  padding: 0 20px 32px;
}
</style>
